module.exports = __webpack_public_path__ + "static/Thumb_NC1_HeartCloud_comp-19fc396d3acf74b609b6d430a6bf0711.png";